<template>
  <div v-loading="fetchInProgress">
    <h3 class="margin-bottom-30">Showroom: {{ event.name }}</h3>

    <div class="w-[400px]">
      <div class="form-group">
        <label>Name</label>
        <TextField
          :value="event.name"
          placeholder="Name"
          @blur="onNameChanged($event.target.value)"
        />
      </div>

      <div class="form-group">
        <label>Program <span class="text-gray-200">(optional)</span></label>
        <EventEditorProgramField
          v-if="orgId"
          :org-id="orgId"
          :value="event.program_id"
          @update="onProgramChanged"
        />
      </div>
    </div>

    <el-tabs v-model="tab" class="event-details-tabs">
      <el-tab-pane
        :label="tabToLabelMap[tabs.COMPANIES]"
        :name="tabs.COMPANIES"
      >
        <EventCompaniesEditor :event="event" />
      </el-tab-pane>
      <el-tab-pane
        :label="tabToLabelMap[tabs.ATTENDEES]"
        :name="tabs.ATTENDEES"
      >
        <EventUsersEditor :event="event" />
      </el-tab-pane>
      <el-tab-pane
        :label="tabToLabelMap[tabs.INVITE_MESSAGE]"
        :name="tabs.INVITE_MESSAGE"
      >
        <ShowroomInviteMailEditor />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import EventCompaniesEditor from './EventCompaniesEditor.vue'
import EventUsersEditor from './EventUsersEditor.vue'
import ShowroomInviteMailEditor from 'components/showrooms/ShowroomInviteMailEditor'
import TextField from 'components/forms/TextField.vue'
import { mapState } from 'vuex'
import router from 'routes'
import EventEditorProgramField from './EventEditorProgramField.vue'

const tabs = {
  COMPANIES: 'COMPANIES',
  ATTENDEES: 'ATTENDEES',
  INVITE_MESSAGE: 'INVITE_MESSAGE',
}
const queryParamToTabMap = {
  companies: tabs.COMPANIES,
  attendees: tabs.ATTENDEES,
  invite: tabs.INVITE_MESSAGE,
}

const tabToQueryParamMap = {
  [tabs.COMPANIES]: 'companies',
  [tabs.ATTENDEES]: 'attendees',
  [tabs.INVITE_MESSAGE]: 'invite',
}
const tabToLabelMap = {
  [tabs.COMPANIES]: 'Companies',
  [tabs.ATTENDEES]: 'Attendees',
  [tabs.INVITE_MESSAGE]: 'Invite mail editor',
}
const DEFAULT_TAB = tabs.COMPANIES

export default {
  components: {
    EventCompaniesEditor,
    EventUsersEditor,
    ShowroomInviteMailEditor,
    TextField,
    EventEditorProgramField,
  },
  props: {
    eventId: {
      type: [String, Number],
      default: '',
    },
  },
  computed: {
    ...mapState({
      user: (s) => s.user.data,
      event: (s) => s.eventDetails.event,
      fetchInProgress: (s) => s.eventDetails.fetchInProgress,
    }),
    orgId() {
      return this.event ? this.event.organization.id : ''
    },
  },
  data() {
    return {
      tabs: tabs,
      tab: tabs.COMPANIES,
      tabToLabelMap,
    }
  },
  watch: {
    tab(t) {
      const query = { ...router.currentRoute.query, tab: tabToQueryParamMap[t] }
      if (t === DEFAULT_TAB) {
        delete query.tab
      }
      router.replace({
        path: router.currentRoute.path,
        query,
      })
    },
  },
  created() {
    window.vm = this
    this.$store.commit('startupList/clearStartups')
    this.$store.commit('eventDetails/clearStartups')
    this.fetch()

    this.tab = queryParamToTabMap[this.$route.query.tab] || tabs.COMPANIES
  },
  methods: {
    async onNameChanged(name) {
      if (name === this.event.name) {
        return
      }
      await this.$store.dispatch('eventDetails/updateName', { name })
      this.$notify({
        type: 'success',
        title: 'Saved',
        message: 'Name updated',
      })
    },
    async onProgramChanged(programId) {
      if (programId === this.event.program_id) {
        return
      }
      await this.$store.dispatch('eventDetails/update', {
        program_id: programId,
        program_config: {},
      })
      this.$notify({
        type: 'success',
        title: 'Saved',
        message: `Program ${programId ? 'changed' : 'cleared'}`,
      })
    },

    fetch() {
      this.$store.dispatch('eventDetails/fetchUsers', { eventId: this.eventId })
      this.$store.dispatch('eventDetails/fetchStartups', {
        eventId: this.eventId,
      })
    },
  },
}
</script>

<style lang="scss">
.event-details-tabs {
  margin-top: 60px;
}
</style>
